import { render, staticRenderFns } from "./GerarAtendimentoDeRequisicao.vue?vue&type=template&id=b689da46&"
import script from "./GerarAtendimentoDeRequisicao.vue?vue&type=script&lang=js&"
export * from "./GerarAtendimentoDeRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports